module.exports = __webpack_public_path__ + "img/course-17.e54026bf.png";